import { pharmacyTechniciansRouteStore } from '../domain/store';

import { listPharmacyTechnicians } from './index';

export default (e) => {
  pharmacyTechniciansRouteStore.setValue('filterValue', e.target.value);
  pharmacyTechniciansRouteStore.setValue('currentPage', 1);
  return listPharmacyTechnicians();
};
